import React from 'react';
import Button from "components/button";

const Footerbutton = ({formIndex, check, oC1, oC2, oC5}) => {

    const elements = [
        <Button size={'LG'} onClick={oC1}>Suivant</Button>,
        <Button size={'LG'} onClick={oC5}>Confirmer</Button>,
    ]

    // 1-Suivant, 2-Confirmer, 3-Suivant, 4-Confirmer,
    // 5-Suivant(hostId), 6-Confirmer(hostId), 7-Confirmer(submit all)
    const elements2 = [
        <Button size={'LG'} onClick={oC1}>Suivant</Button>,
        <Button size={'LG'} onClick={oC1}>Confirmer</Button>,
        <Button size={'LG'} onClick={oC1}>Suivant</Button>,
        <Button size={'LG'} onClick={oC1}>Confirmer</Button>,
        <Button size={'LG'} onClick={oC1}>Suivant</Button>,
        <Button size={'LG'} onClick={oC1}>Confirmer</Button>,
        <Button size={'LG'} onClick={oC2}>Confirmer</Button>,
    ]

    return (
        <>
            {check ? (
                <>
                    {elements.map((item, index) => {
                        if ((index + 1) === formIndex) return elements[index]
                    })}
                </>
            ) : (
                <>
                    {elements2.map((item, index) => {
                        if ((index + 1) === formIndex) return elements2[index]
                    })}
                </>
            )}
        </>
    );
};

export default Footerbutton;